// extracted by mini-css-extract-plugin
export default {"root":"FourOhFour_root__3oks-","headerText":"FourOhFour_headerText__33JuK","logoCtn":"FourOhFour_logoCtn__1mela","logo":"FourOhFour_logo__1wECU"};